/**
 * Die Startadresse. Sie zeigt nichts, sie entscheidet: wohin gehört dieser Nutzer?
 *
 * Vorher stand hier eine Überschrift mit dem Produktnamen, und das war die ganze Anwendung, die
 * ein frisch Angemeldeter sah. Wer den Bereich hat, wird jetzt dorthin gebracht — Auftraggeber vor
 * Auftragnehmer, weil ein Mitglied eines Auftraggebers dessen Zahlen führt, während das eigene
 * Provisionskonto eine Ansicht daneben ist und über die Kopfzeile in einem Klick erreichbar bleibt.
 *
 * Der Sonderfall am Ende ist echt und kein Zierrat: ein eingeladener Nutzer, dessen Einladung noch
 * nicht angenommen wurde, hat eine gültige Sitzung und keinen einzigen Bereich. Ihm eine leere
 * Seite zu zeigen wäre der zweite Fehler nach dem ersten.
 */
import { createFileRoute } from '@tanstack/react-router'
import type { ReactElement } from 'react'
import { istApiError, istNichtAngemeldet } from '../api'
import { Weiterleitung, useSession } from '../auth'

export const Route = createFileRoute('/')({
  component: Start,
})

function Start(): ReactElement {
  const sitzung = useSession()

  if (sitzung.isPending) return <p role="status">Sitzung wird geprüft …</p>

  if (sitzung.isError) {
    if (istNichtAngemeldet(sitzung.error)) return <Weiterleitung nach="/login" />
    return (
      <p role="alert">
        {istApiError(sitzung.error) ? sitzung.error.message : 'Die Sitzung konnte nicht geprüft werden.'}
      </p>
    )
  }

  const { tenants, contractors, user } = sitzung.data
  const ersterTenant = tenants[0]
  if (ersterTenant !== undefined) {
    return <Weiterleitung nach="/t/$tenantId/dashboard" params={{ tenantId: ersterTenant.id }} />
  }
  if (contractors.length > 0) return <Weiterleitung nach="/me/provisionen" />
  if (user.is_platform_admin) return <Weiterleitung nach="/admin/mandanten" />

  return (
    <div className="seite">
      <h1>FinSuites Accounting</h1>
      <p role="status">
        Ihr Zugang ist angelegt, aber noch keinem Auftraggeber und keinem Auftragnehmer-Profil
        zugeordnet. Sobald jemand Sie einlädt, erscheint der Bereich hier. Öffnen Sie eine
        Einladung, die Sie per E-Mail bekommen haben, über den Link darin.
      </p>
    </div>
  )
}
